export default {
  tagManagerDebug: true, // Google Tag Manager を本番以外でも送信可能にする
};
